'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("addCurrency", function () {
  return function addCurrencyFilter(value, sign) {
    var currency = sign || "€";
    return value + " " + currency;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/currency.js
// module id = 2699
// module chunks = 13